<ion-header>
  <ion-toolbar mode="ios" [color]="color ? color : desktop ? '' : 'primary'">
    <ion-buttons slot="start" [hidden]="desktop">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

    <ion-title
      [ngClass]="{ 'ion-text-center': !desktop, 'ion-text-left': desktop }">
      <img
        *ngIf="logo && (!desktop || !color || color != 'transparent')"
        (click)="goHome()"
        [src]="logo"
        [alt]="mallName"
        [class]="logoClass"
        #imageElement />
      <img
        *ngIf="logo && desktop && color && color == 'transparent'"
        (click)="goHome()"
        [src]="logo"
        [alt]="mallName"
        [class]="logoClass"
        #imageElement />

      <ion-text id="header-operating-times" class="ion-hide-lg-down">
        <a routerLink="/contact">{{ openingTime }}</a>
      </ion-text>

      <ion-text id="navigation" [hidden]="!desktop">
        <ul>
          <li *ngFor="let item of menus">
            <ng-container *ngIf="item.children; else topLevelItem">
              <a class="dropdown-parent">{{ item.title }}</a>
              <ul>
                <li *ngFor="let child of item.children">
                  <a
                    hrefToRouterLink
                    [href]="linkToPage(child)"
                    [attr.target]="child.newWindow ? '_blank' : '_self'"
                    >{{ child.title }}</a
                  >
                </li>
              </ul>
            </ng-container>
            <ng-template #topLevelItem>
              <a
                hrefToRouterLink
                [href]="linkToPage(item)"
                [attr.target]="item.newWindow ? '_blank' : '_self'"
                >{{ item.title }}</a
              >
            </ng-template>
          </li>
          <ng-container>
            <li *ngIf="!user; else loggedInUser">
              <a routerLink="/auth/login"> Login </a>
            </li>
            <ng-template #loggedInUser>
              <li class="dropdown-right">
                <a>
                  <ion-icon name="person-outline"></ion-icon>
                </a>
                <ul>
                  <li *ngFor="let child of profileLinks">
                    <a
                      hrefToRouterLink
                      [href]="linkToPage(child)"
                      [attr.target]="child.newWindow ? '_blank' : '_self'"
                      >{{ child.title }}</a
                    >
                  </li>
                  <li>
                    <a (click)="logOutUser()">Log Out</a>
                  </li>
                </ul>
              </li>
            </ng-template>
          </ng-container>
          <li>
            <a (click)="presentModal()">
              <ion-icon name="search-outline"></ion-icon>
            </a>
          </li>
        </ul>
      </ion-text>
    </ion-title>

    <ion-buttons slot="end" [hidden]="desktop" (click)="presentModal()">
      <ion-icon size="large" name="search-outline"></ion-icon>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
